import { render, staticRenderFns } from "./QuizAnswerLine.vue?vue&type=template&id=3521ca1f&scoped=true"
import script from "./QuizAnswerLine.vue?vue&type=script&lang=js"
export * from "./QuizAnswerLine.vue?vue&type=script&lang=js"
import style0 from "./QuizAnswerLine.vue?vue&type=style&index=0&id=3521ca1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3521ca1f",
  null
  
)

export default component.exports